export default __webpack_public_path__ + "static/media/va.bbc2e5e3.svg";